import { render, staticRenderFns } from "./reporting-table.cmp.vue?vue&type=template&id=7533d8aa&scoped=true&"
import script from "./reporting-table.cmp.vue?vue&type=script&lang=ts&"
export * from "./reporting-table.cmp.vue?vue&type=script&lang=ts&"
import style0 from "./reporting-table.cmp.vue?vue&type=style&index=0&id=7533d8aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7533d8aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
